import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import ModernHeader from './ModernHeader';
import ModernFooter from './ModernFooter';
import './layout.css';
import '../styles/global.css';

function ModernLayout({ children }) {
  const data = useStaticQuery(graphql`
    query ModernSiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ModernHeader siteTitle={data.site.siteMetadata.title} />
      <div style={{ flex: 1 }}>
        <main>{children}</main>
      </div>
      <ModernFooter siteTitle={data.site.siteMetadata.title} />
    </div>
  );
}

ModernLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModernLayout;

